import Interaction from './Interaction.container';

export default Interaction;



// WEBPACK FOOTER //
// ./src/ui/interaction/index.js